import styled from 'styled-components';

export const Container = styled.div`
  background: #f9f9fb 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoginBox = styled.div`
  width: 495px;
  border: 1px solid #dfdfe6;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 8px;
  opacity: 1;
  padding: 20px;
`;

export const ImageContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin: 0 0 20px 0;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;
export const Label = styled.label`
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #2e384d;
  text-transform: uppercase;
  opacity: 1;
  margin-bottom: 8px;
`;
export const Input = styled.input`
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #dfe3e8;
  border-radius: 4px;
  opacity: 1;
  width: 335px;
  height: 45px;
  font-size: 14px;
  letter-spacing: 0px;
  color: #6b7786;
  opacity: 1;
  padding-left: 16px;
`;

export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const ButtonLogin = styled.button`
  width: 335px;
  height: 40px;
  background: #2699fb 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  border: none;
  color: #fff;
  font-size: 12px;
  opacity: 1;
  font-weight: 600;
  margin-top: 16px;
`;

export const ForgetPassword = styled.a`
  color: #2493eb;
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #2493eb;
  opacity: 1;
  margin: 0 auto;
  padding: 12px 0 16px 0;
`;

export const LineContent = styled.div`
  width: 335px;
  text-align: center;
  border-bottom: 1px solid #dfdfe6;
  line-height: 0.1em;
  margin: 10px 0 20px;
`;

export const Text = styled.span`
  background: #fff;
  padding: 0 10px;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #6b7786;
  text-transform: lowercase;
  opacity: 1;
`;

export const ButtonCreateAccount = styled.button`
  width: 335px;
  height: 40px;
  border: 0.5px solid #2699fb;
  background: #fff;
  border-radius: 4px;
  opacity: 1;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #2699fb;
  text-transform: uppercase;
  opacity: 1;
`;

export const Backto = styled.a`
  margin-top: 8px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #2493eb;
  opacity: 1;
  cursor: pointer;
`;
